module.exports = __webpack_public_path__ + "static/media/unavailable-cookie.4843149b.svg";